import {
    validateOrganizationNumber,
    validateAlias,
    validateEmail
} from './api';
import * as Validator from 'validator';

export const formRules = (
    t,
    antiForgeryToken,
    serverErrors,
    setServerErrors
) => {
    const setServerValidationError = (error, field) => {
        if (error) {
            setServerErrors({
                ...serverErrors,
                [field]: error.code
            });
        } else if (!error) {
            const _serverErrors = { ...serverErrors };
            delete _serverErrors[field];
            setServerErrors(_serverErrors);
        }
    };

    return {
        organizationNumber: {
            required: t('registration_validation_required_organizationnumber'),
            validate: {
                isValid: async (value) => {
                    const { success, error } = await validateOrganizationNumber(
                        value,
                        antiForgeryToken
                    );
                    setServerValidationError(error, 'organizationNumber');
                    return success;
                }
            }
        },
        companyName: {
            required: t('registration_validation_required_companyname'),
            minLength: {
                value: 2,
                message: t('registration_validation_minlength_companyname')
            },
            maxLength: {
                value: 40,
                message: t('registration_validation_maxlength_companyname')
            },
            pattern: {
                value: /^[0-9\u0041-\u024F -:]+$/,
                message: t('registration_validation_invalid_characters')
            }
        },
        streetName: {
            required: t('registration_validation_required_streetname'),
            minLength: {
                value: 1,
                message: t('registration_validation_minlength_streetname')
            },
            maxLength: {
                value: 50,
                message: t('registration_validation_maxlength_streetname')
            },
            pattern: {
                value: /^[0-9\u0041-\u024F -:]+$/,
                message: t('registration_validation_invalid_characters')
            }
        },
        zipCode: {
            required: t('registration_validation_required_zipcode'),
            minLength: {
                value: 4,
                message: t('registration_validation_invalid_zipcode')
            },
            maxLength: {
                value: 8,
                message: t('registration_validation_invalid_zipcode')
            },
            validate: (value) => {
                const rawValue = value.replace(/[ -]/g, '');
                return (
                    (Validator.isNumeric(rawValue) && rawValue.length === 5) ||
                    t('registration_validation_invalid_zipcode')
                );
            }
        },
        town: {
            required: t('registration_validation_required_town'),
            minLength: {
                value: 2,
                message: t('registration_validation_minlength_town')
            },
            maxLength: {
                value: 36,
                message: t('registration_validation_maxlength_town')
            },
            pattern: {
                value: /^[\u0041-\u024F -:]+$/,
                message: t('registration_validation_invalid_town')
            }
        },
        alias: {
            required: t('registration_validation_required_alias'),
            minLength: {
                value: 2,
                message: t('registration_validation_minlength_alias')
            },
            maxLength: {
                value: 50,
                message: t('registration_validation_maxlength_alias')
            },
            pattern: {
                value: /^[0-9\u0041-\u024F -:]+$/,
                message: t('registration_validation_invalid_characters')
            },
            validate: async (value) => {
                const { success, error } = await validateAlias(
                    value,
                    antiForgeryToken
                );
                setServerValidationError(error, 'alias');
                return success;
            }
        },
        phoneNumber: {
            required: t('registration_validation_required_phonenumber'),
            minLength: {
                value: 4,
                message: t('registration_validation_minlength_phonenumber')
            },
            maxLength: {
                value: 15,
                message: t('registration_validation_maxlength_phonenumber')
            },
            pattern: {
                value: /^(\+?\d{2})?[\d\- ]+$/,
                message: t('registration_validation_invalid_phonenumber')
            }
        },
        emailAddress: {
            required: t('registration_validation_required_email'),
            minLength: {
                value: 5,
                message: t('registration_validation_invalid_length_email')
            },
            maxLength: {
                value: 255,
                message: t('registration_validation_maxlength_email')
            },
            validate: {
                isValid: async (value) => {
                    const { success, error } = await validateEmail(
                        value,
                        antiForgeryToken
                    );
                    setServerValidationError(error, 'emailAddress');
                    return success;
                }
            }
        },
        contactFirstName: {
            required: t('registration_validation_required_firstname'),
            minLength: {
                value: 2,
                message: t('registration_validation_minlength_firstname')
            },
            maxLength: {
                value: 30,
                message: t('registration_validation_maxlength_firstname')
            },
            pattern: {
                value: /^[\u0041-\u024F -:]+$/,
                message: t('registration_validation_invalid_characters')
            }
        },
        contactLastName: {
            required: t('registration_validation_required_lastname'),
            minLength: {
                value: 2,
                message: t('registration_validation_minlength_lastname')
            },
            maxLength: {
                value: 30,
                message: t('registration_validation_maxlength_lastname')
            },
            pattern: {
                value: /^[\u0041-\u024F -:]+$/,
                message: t('registration_validation_invalid_characters')
            }
        },
        contactSsn: {
            required: t('registration_validation_required_ssn'),
            pattern: {
                value: /^(\d{2})?(\d{6})-?(\d{4})$/,
                message: t('registration_validation_ssn')
            }
        },
        terms: {
            required: t('registration_validation_required_terms')
        },
        emailTerms: {
            required: t('registration_validation_privacy_policy')
        }
    };
};
